import { render, staticRenderFns } from "./POILandscape.vue?vue&type=template&id=4f332a92"
import script from "./POILandscape.vue?vue&type=script&lang=js"
export * from "./POILandscape.vue?vue&type=script&lang=js"
import style0 from "./POILandscape.vue?vue&type=style&index=0&id=4f332a92&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports